<script>
    export let sidebarInterface;

    $: count = sidebarInterface ? sidebarInterface.count : 0;

    function reload() {
        sidebarInterface.reload();
    }
</script>

<div class="sidebar-controls">
    <button class="btn btn-sm" on:click={reload} title="Uppdatera inkorgen (U)"><i class="fas fa-redo-alt" /></button>
    <span class="float-right count">{count ? count : ''}</span>
</div>

<style>
    /* Placed by the shell, so there is no position or size here beyond filling what it is
       given. The left inset keeps the button clear of a notch in landscape. */
    .sidebar-controls {
        height: 100%;
        background: #eee;
        margin: 0;
        padding: 4px;
        padding-left: calc(4px + env(safe-area-inset-left, 0px));
        border: 1px solid #666;
        border-width: 0 1px 1px 0;
    }

    .count {
        margin-top: 5px;
        margin-right: 8px;
    }
</style>
